export const MARKET_SUMMARY_ORDER = ['XU100', 'BTC', 'ETH', 'BRENT'];

const SOURCE_LABELS = {
  TRUNCGIL: 'Trunçgil',
  BINANCE: 'Binance',
  EIA_FRED: 'FRED'
};

export const hasMarketPrice = item => Number.isFinite(item?.price) && item.price > 0;

export const sortMarketSummary = items => [...(items || [])].sort((a, b) =>
  MARKET_SUMMARY_ORDER.indexOf(a.symbol) - MARKET_SUMMARY_ORDER.indexOf(b.symbol)
);

export const getMarketSourceLabel = item => item?.sourceLabel || SOURCE_LABELS[item?.source] || 'Kaynak yok';

export const getMarketStatusLabel = item => {
  if (!hasMarketPrice(item)) return 'Veri yok';
  if (item?.symbol === 'BRENT') return 'Günlük veri';
  if (['Açık', 'Kapalı', 'Son veri', 'Günlük veri'].includes(item?.statusLabel)) return item.statusLabel;
  if (item?.isStale) return 'Son veri';
  return ['BTC', 'ETH'].includes(item?.symbol) ? 'Açık' : 'Kapalı';
};

export const formatMarketPrice = item => {
  if (!hasMarketPrice(item)) return '—';
  const value = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(item.price);
  if (item.symbol === 'XU100') return value;
  return `${value} ${item.currency}`;
};
